export default __webpack_public_path__ + "static/media/4.ba35e2d6.png";